import { CSVEntity } from 'shared'
import { HelpMessage } from 'utils/constants'
import { ActionModal } from './components/ActionModal'
import { RevertSubmittalModal } from './components/RevertSubmittalModal'
import { useSubmittalTrackerContext } from '../../SubmittalTrackerContext'
import { useColumns } from './hooks/useColumns/index'
import CIMSTable from 'components/CIMSTable'
import { useCreateOptions } from './hooks/useCreateOptions'
import { useEditOptions } from './hooks/useEditOptions'
import { useRemoveOptions } from './hooks/useRemoveOptions'
import { useCustomRowOptions } from './hooks/useCustomRowOptions'
import { useRestoreOptions } from './hooks/useRestoreOptions'
import { usePayItemsOptions } from './hooks/usePayItemsOptions'
import { useExpandOptions } from './hooks/useExpandOptions'
import PDFModal from './components/PDFModal'
import CreateModal from './hooks/useCreateOptions/components/CreateModal'

const SubmittalTrackerTable: React.FC = () => {
  const {
    payItemGlobalId,
    records,
    refetch,
    fetching,
    RepairModal,
    refetchMetadata,
  } = useSubmittalTrackerContext()
  const TrackerHelp = HelpMessage.CAS.SubmittalTracker
  return (
    <CIMSTable
      loading={fetching}
      columns={useColumns()}
      records={records}
      rowKey={'id'}
      actions={{
        header: {
          csv: !!payItemGlobalId
            ? undefined
            : CSVEntity.ConstructionAdminSubmittal,
          onReload: () => {
            refetch()
            refetchMetadata()
          },
          payItems: usePayItemsOptions(),
          create: useCreateOptions(),
          deepLinkKey: ({ previousId, id }) => [previousId, id],
        },
        row: {
          help: `${TrackerHelp.Edit}, ${TrackerHelp.Remove}, ${TrackerHelp.Revert}, ${TrackerHelp.Restore}, ${HelpMessage.UnlockSharePointFolder}, and ${HelpMessage.LockSharePointFolder}`,
          edit: useEditOptions(),
          remove: useRemoveOptions(),
          restore: useRestoreOptions(),
          custom: useCustomRowOptions(),
        },
      }}
      expand={useExpandOptions()}
    >
      <CreateModal />
      <ActionModal />
      <RevertSubmittalModal />
      <PDFModal />
      {RepairModal}
    </CIMSTable>
  )
}

export default SubmittalTrackerTable
